<template>
<div>
 <Header @getLanguageMap='getLanguageMap'></Header>

<NavigationBar></NavigationBar>
<div class="main">
  <div class="container"> 
    <!-- head -->
    <div class="head"> 
      <!-- left -->
      <!-- <div class="left">
        <div class="banner">
          <volist  v-if="shopObj.imgArr && shopObj.imgArr.length > 0">
			<img :src="shopObj.imgArr[selectedIndex]" style="display: inline;" width="300">
			<span v-if="shopObj.category==1"> 
            <img src="/images/Stop.png" style="width: 80px;position: absolute;height: 57px;left: 5px;top: 5px;" />  
            <span style="width: 80px; position: absolute; height: 57px; left: -71px; top: -99px; font-size: 17px; color: white; transform: rotate(-31deg); font-weight: bold;">{{languageMap['停产']}}</span>
           </span>
           <span v-else-if="shopObj.category==2">  
            <img src="/images/New.png" style="width: 60px;position: absolute;height: 60px;left: 5px;top: 5px;" />  
            <span style="width: 60px; position: absolute; height: 60px; left: -59px; top: -98px; font-size: 17px; color: white; transform: rotate(-31deg); font-weight: bold;">{{languageMap['新品']}}</span>
           </span> 
		  </volist>
        </div>
		<div v-if="shopObj.imgArr && shopObj.imgArr.length > 0">
		  <img v-for="(url, index) in shopObj.imgArr" :key="index" :src="url" @click="smallImgClick(index)" style="display: inline;margin-right: 10px;cursor: pointer;" :class="selectedIndex==index ? 'selectShopC' : 'defaultShopC'" width="100">
		</div>
      </div> -->
      <!-- left over --> 
      <!-- right -->
      <div class="right">
        <p class="title" style="text-align: center;" v-html="languageMap[shopObj.name]">
			
		</p>
        <div class="sub"></div>
        <!-- <p class="info">{{languageMap[shopObj.documentSummary]}}</p> -->
      </div>
      
      <!-- right over --> 
    </div>
    <!-- head over --> 
    <!-- content -->
    <div class="content" style="text-align: center;margin-top: 30px;">
      <!-- <ul class="left">
        <li :class="languageMap['fileName']=='chinese.txt'?'liCh':'liEn'">{{languageMap['产品描述']}}</li>
        <li :class="languageMap['fileName']=='chinese.txt'?'liCh':'liEn'">{{languageMap['地址']}}：{{languageMap['北京市通州区瑞都国际中心1105室']}}</li>
<li :class="languageMap['fileName']=='chinese.txt'?'liCh':'liEn'">{{languageMap['电话']}}：010-80816559-810</li>
<li :class="languageMap['fileName']=='chinese.txt'?'liCh':'liEn'">{{languageMap['传真']}}：010-80816559</li>
<li :class="languageMap['fileName']=='chinese.txt'?'liCh':'liEn'">{{languageMap['邮箱']}}：moc@bj-mrkj.com</li>
    
      </ul> -->
      <div class="right">
        <div class="child" style="display:block;">
          <p  v-html="languageMap['fileName']=='chinese.txt' ? shopObj.detailContent : shopObj.detailContentEnglish"></p>
        </div>
      
      </div>
    </div>
    <!-- content over --> 
    <!-- foot -->
 
    <!-- foot over --> 
    <!-- about -->
    <div class="about">
      <div class="aboutTitle"> <span class="title">{{languageMap['相关产品']}}</span>
        <div class="sub"></div>
      </div>

	<div class="container" >
	   <a :href="'/#/case/detail?id='+item.id+'&type='+item.type" v-for="(item,index) in xgcpShopList" :key="index" @click="toDetail(item.id)">
        <div class="child">
          <div class="childImg">
		    <img v-if="item.imgArr && item.imgArr.length > 0" :src="item.imgArr[0]">
			
		  </div>
          <div class="childTitle">
            <p v-html="languageMap[item.name]"></p>
          </div>
          <div class="childSub"></div>
          <div class="childInfo"> <img src="/images/listicon.jpg"> <span>{{languageMap['详细信息']}}</span> </div>
        </div>
        </a>
	</div>	
     

    </div>
    <!-- about over --> 
  </div>
</div>
 <Footer></Footer>
</div>
</template>

<style scoped>
/* productinfo.css */
.main {
	padding:68px 0 0 0;
}
.main .head {
	padding-bottom:0px;
}
.main .head:after {
	content: "020";
	display: block;
	height: 0;
	clear: both;
	visibility:hidden;
}
.main .head .left {
	float:left;
	position:relative;
	width:360px;
}
.main .head .left .banner {
	height: 300px;
border: 1px solid #e8e8e8;
overflow: hidden;
width: 323px;
margin-bottom: 10px;
line-height: 300px;
}
.defaultShopC{
border: 1px solid #e8e8e8;
}
.selectShopC{
border: 1px solid #b21f24;
}
.main .head .left .banner img {
	max-width:100%;
	max-height:100%;
}
.main .head .left .childs {
	position:relative;
	width:630px;
	height:150px;
	overflow: hidden;
	padding: 12px 29px 0 37px;
}
.main .head .left .childs:after {
	content: "020";
	display: block;
	height: 0;
	clear: both;
	visibility:hidden;
}
.main .head .left .child {
	cursor:pointer;
	float:left;
	width:148px;
	height:148px;
	border:1px solid #e8e8e8;
	margin-right:6px;
}
.main .head .left .child:nth-child(4) {
	margin-right:0;
}
.main .head .left .child img {
	width:100%;
	height:100%;
	vertical-align:middle;
}
.main .head .left .leftBtn {
	position: absolute;
	left: 0;
	top: 50px;
}
.main .head .left .rightBtn {
	position: absolute;
	right: 0px;
	top: 50px;
}
.main .head .left .logoBtn {
	cursor:pointer;
}
.main .head .right {
	float:right;
	width:100%;
	color:#666;
	font-size:16px;
}
.main .head .right .title {
	line-height:50px;
	color:#333333;
	font-size:38px;
	padding-bottom:40px;
}
.main .head .right .sub {
	height:4px;
	border-top:1px solid #e3e3e3;
}
.main .head .right .info {
	padding:0 0 52px 0;
	line-height: 24px;
}
.main .head .right .tag {
	line-height:24px;
}
.main .content .right p {
	padding:0;
	line-height:24px;
	color:#666;
	font-size:14px;
}
.main .content .right div {
	padding:0;
	line-height:24px;
	color:#666;
	font-size:14px;
}
.main .content:after {
	content: "020";
	display: block;
	height: 0;
	clear: both;
	visibility:hidden;
}
.main .content .left {
	width:360px;
	float:left;
}
.main .content .left li {
	height:50px;
	line-height:50px;
	border-bottom:1px solid #d6d6d6;
	color:#666;
	cursor:pointer;
}

.main .content .left .liCh {
	font-size:14px;
}

.main .content .left .liEn {
	font-size:10px;
}

.main .content .right {
	position:relative;
	width:100%;
	float:right;
}
.main .content .right .child {
	display:none;
}
.main .content .right .title {
	color:#333333;
	font-size:16px;
	line-height:22px;
}
.main .content .right .info {
	padding:22px 0;
	line-height:22px;
	color:#666;
	font-size:14px;
}
.main .foot {
	position:relative;
	text-align:center;
	height:78px;
	border-top:1px solid #bebebe;
	border-bottom:1px solid #bebebe;
	margin:60px 0;
}
.main .foot .child {
	display:inline-block;
*display:inline;
*zoom:1;
	position:relative;
	width:193px;
	height:100%;
	border-left:1px solid #ddd;
}
.main .foot a:nth-child(1) .child {
	border-left:0;
}
.main .foot .child .childIcon, .main .foot .child .childInfo {
	display:inline-block;
*display:inline;
*zoom:1;
	vertical-align:middle;
}
.main .foot .child .childIcon {
	margin-top:20px;
	position:relative;
	background:#666;
	width:38px;
	height:38px;
	text-align:center;
	line-height:38px;
	border-radius:38px;
	-moz-border-radius:38px;
	-ms-border-radius:38px;
	-o-border-radius:38px;
	-webkit-border-radius:38px;
}
.main .foot .child .childIcon img {
	vertical-align:middle;
}
.main .foot .child .childIcon img {
	transition-duration: .5s;
	-ms-transition-duration: .5s;
	-moz-transition-duration: .5s;
	-webkit-transition-duration: .5s;
}
.main .foot .child:hover .childIcon img {
	transform:rotate(360deg);
	-moz-transform:rotate(360deg);
	-ms-transform:rotate(360deg);
	-o-transform:rotate(360deg);
	-webkit-transform:rotate(360deg);
}
.main .foot .child .childInfo {
	padding-left:12px;
	text-align:left;
	margin-top: 18px;
}
.main .foot .child .childInfo p {
	color:#666;
	font-size:14px;
}
.main .about {
	position:relative;
	padding:66px 0 100px 0;
}
.main .about .aboutTitle {
	position:relative;
	height:24px;
	padding-bottom:40px;
}
.main .about .aboutTitle span {
	position:relative;
	z-index:1;
	line-height:24px;
	font-size:18px;
	color:#333333;
	padding-right:20px;
	background:#fff;
}
.main .about .aboutTitle .sub {
	position:absolute;
	height:6px;
	background:#e8e8e8;
	top:10px;
	left:0px;
	width:100%;
}
.main .about .child {
	position:relative;
	float:left;
	width:288px;
	border:1px solid #e8e8e8;
	margin-left:12px;
}
.main .about a:nth-child(1) .child {
	margin-left:0;
}
.main .about .child .childImg {
	width:288px;
	height:288px;
	line-height:288px;
	text-align:center;
}
.main .about .child .childImg img {
	vertical-align:middle;
	max-width:90%;
	max-height:90%;
}
.main .about .child {
	transition-duration: .5s;
	-ms-transition-duration: .5s;
	-moz-transition-duration: .5s;
	-webkit-transition-duration: .5s;
}
.main .about .child:hover {
	-webkit-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-moz-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-ms-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-o-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
}
.main .about .child .childTitle {
	position:relative;
	height:60px;
	text-align:center;
}
.main .about .child .childTitle p {
	line-height:20px;
	padding-top:14px;
	color:#006FCF;
}
.main .about .child .childSub {
	height:5px;
	width:250px;
	margin:0 auto;
	border-top:1px solid #e5e5e5;
	border-bottom:1px solid #e5e5e5;
}
.main .about .child .childInfo {
	height:54px;
	line-height:54px;
	text-align:center;
	color:#006FCF;
	font-size:14px;
}
.main .about .child .childInfo img, .main .about .child .childInfo span {
	vertical-align:middle;
}
.bdsharebuttonbox {
	position:absolute;
	top:0;
	left:0px;
	width: 100%;
	height: 100%;
	z-index: 1;
}
.bdsharebuttonbox a {
	display:none;
}
.bdsharebuttonbox .bds_weixin {
	width: 100%;
	height: 100%;
	display:block;
	opacity:0 !important;
	filter: alpha(opacity=0) !important;
}
 @media (max-width: 639px) {
.main .head .left {
	float:left;
	position:relative;
	width:660px;
}
.main .head .left .banner {
	height:500px;
	border:1px solid #e8e8e8;
	overflow:hidden;
	margin: 0 auto;
	width: 99%;
}
.main .head .left .banner img {
	max-width:100%;
	max-height:100%;
}
.main .head .left .childs {
	position:relative;
	width:80%;
	height:75px;
	overflow: hidden;
	padding: 12px 29px 0 37px;
}
.main .head .left .childs:after {
	content: "020";
	display: block;
	height: 0;
	clear: both;
	visibility:hidden;
}
.main .head .left .child {
	cursor:pointer;
	float:left;
	width:148px;
	height:148px;
	border:1px solid #e8e8e8;
	margin-right:6px;
}
.main .head .left .child:nth-child(4) {
	margin-right:0;
}
.main .head .left .child img {
	width:100%;
	height:100%;
	vertical-align:middle;
}
.main .head .left .leftBtn {
	position: absolute;
	left: 0;
	top: 20px;
}
.main .head .left .rightBtn {
	position: absolute;
	right: 0px;
	top: 20px;
}
.main .head .left .logoBtn {
	cursor:pointer;
}
.main {
	padding:20px 0 0 0;
}
.main .head {
	padding-bottom:15px;
}
.main .head .left {
	float:none;
	width:100%;
}
.main .head .left .banner {
	height:100%;
}
.main .head .left .childs {
	padding-top:6px;
}
.main .head .left .child {
	width:23%;
	height:71px;
	margin-right:1%;
}
.main .head .left .child:nth-child(4) {
	margin-right:0;
}
.main .head .right {
	float:none;
	width:100%;
	font-size:12px;
	padding-top:20px;
}
.main .head .right .title {
	line-height:22px;
	font-size:14px;
	padding-bottom:6px;
}
.main .head .right .sub {
	height:2px;
}
.main .head .right .info {
	padding:10px 0 10px 0;
}
.main .head .right .tag {
	line-height:20px;
	font-size:12px;
}
.main .content .left {
	width:100%;
	float:none;
}
.main .content .left li {
	height:30px;
	line-height:30px;
	font-size:12px;
}
.main .content .right {
	width:auto;
	padding:10px 12px;
	float:none;
	margin-top:10px;
}
.main .content .right .title {
	font-size:14px;
	line-height:22px;
}
.main .content .right .info {
	padding:6px 0;
	line-height:18px;
	font-size:14px;
}
.main .foot {
	height:60px;
	margin:20px 0;
}
.main .foot .child {
	width:22%;
}
.main .foot .child .childIcon {
	margin-top:10px;
	width:38px;
	height:38px;
	line-height:38px;
	border-radius:38px;
	-moz-border-radius:38px;
	-ms-border-radius:38px;
	-o-border-radius:38px;
	-webkit-border-radius:38px;
}
.main .foot .child .childInfo {
	display:none;
}
.main .about {
	padding:0px 0 40px 0;
	display:none;
}
.main .about .aboutTitle {
	height:24px;
	padding-bottom:40px;
}
.main .about .aboutTitle span {
	line-height:20px;
	font-size:14px;
	padding-right:8px;
}
.main .about .aboutTitle .sub {
	height:4px;
	top:8px;
}
.main .about .child {
	width:288px;
	margin:10px auto;
	float:none;
	display:inline-block;
*display:inline;
*zoom:1;
}
.main .about .child .childImg {
	width:288px;
	height:288px;
	line-height:288px;
}
.main .about .child .childTitle {
	height:60px;
}
.main .about .child .childTitle p {
	line-height:20px;
	padding-top:14px;
}
.main .about .child .childSub {
	height:5px;
	width:250px;
}
.main .about .child .childInfo {
	height:54px;
	line-height:54px;
	font-size:14px;
}
}
@media (min-width: 640px) and (max-width:1023px ) {
.main .head .left {
	float:left;
	position:relative;
	width:660px;
}
.main .head .left .banner {
	height:500px;
	border:1px solid #e8e8e8;
	overflow:hidden;
	margin: 0 auto;
	width: 500px;
}
.main .head .left .banner img {
	max-width:100%;
	max-height:100%;
}
.main .head .left .childs {
	position:relative;
	width:87%;
	height:126px;
	overflow: hidden;
	padding: 12px 29px 0 37px;
}
.main .head .left .childs:after {
	content: "020";
	display: block;
	height: 0;
	clear: both;
	visibility:hidden;
}
.main .head .left .child {
	cursor:pointer;
	float:left;
	width:148px;
	height:148px;
	border:1px solid #e8e8e8;
	margin-right:6px;
}
.main .head .left .child:nth-child(4) {
	margin-right:0;
}
.main .head .left .child img {
	width:100%;
	height:100%;
	vertical-align:middle;
}
.main .head .left .leftBtn {
	position: absolute;
	left: 0;
	top: 50px;
}
.main .head .left .rightBtn {
	position: absolute;
	right: 0px;
	top: 50px;
}
.main .head .left .logoBtn {
	cursor:pointer;
}
.main {
	padding:40px 0 0 0;
}
.main .head {
	padding-bottom:30px;
}
.main .head .left {
	float:none;
	width:100%;
}
.main .head .left .banner {
	height:610px;
}
.main .head .left .childs {
	padding-top:12px;
}
.main .head .left .child {
	width:122px;
	height:124px;
	margin-right:6px;
}
.main .head .left .child:nth-child(4) {
	margin-right:0;
}
.main .head .right {
	float:none;
	width:100%;
	font-size:16px;
	padding-top:40px;
}
.main .head .right .title {
	line-height:26px;
	font-size:20px;
	padding-bottom:20px;
}
.main .head .right .sub {
	height:4px;
}
.main .head .right .info {
	padding:20px 0 20px 0;
}
.main .head .right .tag {
	line-height:24px;
}
.main .content .left {
	width:100%;
	float:none;
}
.main .content .left li {
	height:50px;
	line-height:50px;
	font-size:14px;
}
.main .content .right {
	width:auto;
	padding:28px 36px;
	float:none;
	margin-top:20px;
}
.main .content .right .title {
	font-size:16px;
	line-height:22px;
}
.main .content .right .info {
	padding:22px 0;
	line-height:22px;
	font-size:14px;
}
.main .foot {
	height:78px;
	margin:60px 0;
}
.main .foot .child {
	width:24%;
}
.main .foot .child .childIcon {
	margin-top:20px;
	width:38px;
	height:38px;
	line-height:38px;
	border-radius:38px;
	-moz-border-radius:38px;
	-ms-border-radius:38px;
	-o-border-radius:38px;
	-webkit-border-radius:38px;
}
.main .foot .child .childInfo {
	padding-left:12px;
	margin-top: 18px;
}
.main .foot .child .childInfo p {
	font-size:14px;
}
.main .about {
	padding:0px 0 100px 0;
}
.main .about .aboutTitle {
	height:24px;
	padding-bottom:40px;
}
.main .about .aboutTitle span {
	line-height:24px;
	font-size:18px;
	padding-right:20px;
}
.main .about .aboutTitle .sub {
	height:6px;
	top:10px;
}
.main .about .child {
	float:none;
	display:inline-block;
*display:inline;
*zoom:1;
	width:288px;
	margin:6px 6px 0 0;
}
.main .about a:nth-child(1) .child {
	margin-left:0;
}
.main .about .child .childImg {
	width:288px;
	height:288px;
	line-height:288px;
}
.main .about .child .childTitle {
	height:60px;
}
.main .about .child .childTitle p {
	line-height:20px;
	padding-top:14px;
}
.main .about .child .childSub {
	height:5px;
	width:250px;
}
.main .about .child .childInfo {
	height:54px;
	line-height:54px;
	font-size:14px;
}
}
@media (min-width: 1024px) and (max-width:1199px ) {
.main {
	padding:40px 0 0 0;
}
.main .head {
	padding-bottom:70px;
}
.main .head .left {
	width:504px;
}
.main .head .left .banner {
	height:498px;
}
.main .head .left .child {
	width:120px;
	height:120px;
	margin-right:5px;
}
.main .head .left .child:nth-child(4) {
	margin-right:0;
}
.main .head .right {
	width:445px;
	font-size:16px;
}
.main .content .left {
	width:228px;
}
.main .content .right {
	width:637px;
	padding:28px 36px;
}
.main .about {
	padding:20px 0 60px 0;
}
.main .about .child {
	float:none;
	display:inline-block;
*display:inline;
*zoom:1;
	margin:10px 10px 0 0;
}
}
@media (min-width: 1200px) and (max-width:1439px ) {
}
@media (min-width: 1440px) and (max-width:1920px ) {
}


</style>

<script>
import store from "@/store";
import config from "@/config";
import Header from "@/components/front/Header.vue";
import Footer from "@/components/front/Footer.vue";
import NavigationBar from "@/components/front/NavigationBar.vue";
export default {
  data() {
    return {
		id:null,
		shopObj:{},
		selectedIndex : 0,
		languageMap:{},
		xgcpShopList: []
    };
  },
  mounted() {
	 
	  this.init();
	  this.id=this.$route.query.id;
	  this.queryByParam();
	  this.updateShopBrowseCount();
  },
  beforeDestroy(){

  },
  methods: {
    init(){
		$(function(){
	$(".main .head .banner img:eq(0)").show();
	$(".main .head .childs .child").click(function(){
		var index=$(".main .head .childs .child").index($(this));
		$(".main .head .banner img").not($(".main .head .banner img:eq("+index+")")).hide();
		$(".main .head .banner img:eq("+index+")").fadeIn(500);
	});
	
	$(".main .content .left li").click(function(){
		var index=$(".main .content .left li").index($(this));
		$(".main .content .right .child").not($(".main .content .right .child:eq("+index+")")).hide();
		$(".main .content .right .child:eq("+index+")").show();
	});
});
	},
   queryByParam(){
     let url =  config.url + "FrontController/queryByParam.action";
      let param = {id:this.id};
      this.$http.post(url, param).then(res => {
        let data = res.data;
        if(data.resultCode == 200){
			document.documentElement.scrollTop=0;
			if(data.data){
			  this.shopObj=data.data[0];
			  if(this.shopObj.imgUrls){
				  this.shopObj['imgArr'] = this.shopObj.imgUrls.split(',');
			  }
			  this.queryXgcp();
			}else{
			  this.shopObj={};
			}
        }
      }) .catch(err => {
        console.log(err);
      });
   },
   toDetail(id){
	   this.id=id;
	   this.selectedIndex=0;
	   this.queryByParam();
   },
   getCookie(name) {  //this.languageMap['获取cookie']
  var arr = null;
  var reg = new RegExp("(^| )"+name+"=([^;]*)(;|$)");
  var arr=document.cookie.match(reg);
  if(arr) {
     return unescape(arr[2]);
  } else {
     return null;
  }
 },
    getLanguageMap(e){
      this.languageMap=e;
      this.$emit('getLanguageMap',e)
	},
	smallImgClick(index){  //小图点击
		this.selectedIndex = index;  

	},
	queryXgcp(){ //查询相关产品
	  let url =  config.url + "FrontController/queryByParam.action";
      let param = {type: this.shopObj.type};
      this.$http.post(url, param).then(res => {
        let data = res.data;
        if(data.resultCode == 200){
		  let xgcpShopList = data.data || [];
		  let newXgcpShopList = []; 
		  for(let i=0; i < 4; i++){
			  if(i < xgcpShopList.length){
				  newXgcpShopList.push(xgcpShopList[i]);
			  }
		  }
		  this.xgcpShopList = newXgcpShopList;

		  for(let i=0; i < this.xgcpShopList.length; i++){
			let shopObj = this.xgcpShopList[i];
		    if(shopObj.imgUrls){
			   shopObj['imgArr'] = shopObj.imgUrls.split(',');
			}
		  }
        }
      }) .catch(err => {
        console.log(err);
      });
	},
	updateShopBrowseCount(){  //修改产品浏览次数
	  let url =  config.url + "FrontController/updateShopBrowseCount.action";
      let param = {
	    id: this.id  
	  };
      this.$http.post(url, param).then(res => {
        let data = res.data;
        console.log('updateShopBrowseCount='+data.resultCode)
      }) .catch(err => {
        console.log(err);
      });
	}
  },
  components: {
    Header,
    Footer,
    NavigationBar
  }
};
</script>
